import * as Yup from "yup";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";

import CustomAlert from "../../components/CustomAlert";
import CustomDialog from "../../components/CustomDialog";
import DayJsUtils from "@date-io/dayjs";
import { KeyboardDatePicker as FormikKeyboardDatePicker } from "formik-material-ui-pickers";
import { TextField as FormikTextField } from "formik-material-ui";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import dayjs from "dayjs";
import localeEl from "dayjs/locale/el";
import localeEn from "dayjs/locale/en";
import useLocale from "../../../hooks/useLocale";
import { useMutation } from "react-query";
import { useState } from "react";
import GovGrButton from "../../../components/GovGrButton";

const useStyles = makeStyles({
  dialog: {},
  dateContainer: {
    width: "100%",
  },
});

const MedicalAReportModal = ({
  open,
  close,
  refetch,
  values,
  submit,
  setFieldValue,
}) => {
  const classes = useStyles();
  const [error, setError] = useState("");
  const { t, locale } = useLocale();
  dayjs().locale(locale === "el-GR" ? localeEl : localeEn);
  // Mutation for creating data

  return (
    <MuiPickersUtilsProvider
      locale={locale === "el-GR" ? localeEl : localeEn}
      utils={DayJsUtils}
    >
      <CustomDialog
        open={open}
        maxWidth="sm"
        onClose={() => {
          close();
          setError("");
        }}
      >
        <DialogTitle id="form-dialog-title">
          {t("Medical report date")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("Please provide the date of a' medical report")}
          </DialogContentText>
        </DialogContent>
        <CustomAlert
          open={!!error}
          close={() => {
            setError("");
          }}
          message={t("A network error occured, please try again later")}
        />

        <DialogContent className={classes.dialog}>
          <div className={classes.dateContainer}>
            <Field
              component={FormikKeyboardDatePicker}
              disabled={false}
              label={t("To date")}
              format="DD/MM/YYYY"
              style={{ width: "45%", marginBottom: "20px" }}
              showTodayButton
              onChange={(newDate) => {
                setFieldValue("a_medical_date", newDate);

                const comment = `${t("Medical report date")}: ${dayjs(
                  newDate
                ).format("DD/MM/YYYY")}`;
                setFieldValue("history_comment", comment);
              }}
              name="a_medical_date"
              todayLabel={t("Today")}
              cancelLabel={t("Cancel")}
            />
            <Field
              className={classes.commentInput}
              name="history_comment"
              component={FormikTextField}
              style={{ minWidth: 500, width: 500 }}
              variant="outlined"
              multiline
              margin="normal"
              rows={5}
              label={t("Comment")}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <GovGrButton
            onClick={() => {
              submit();
              close();
            }}
            color="primary"
            buttonText={t("Change application status")}
          />

          <GovGrButton
            onClick={() => {
              close();
              setError("");
              setFieldValue("a_medical_date", null);
            }}
            color="primary"
            buttonText={t("Cancel")}
          />
        </DialogActions>
      </CustomDialog>
    </MuiPickersUtilsProvider>
  );
};

export default MedicalAReportModal;
